"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[30],{

/***/ 91435:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dt": function() { return /* binding */ defaultBlockStyle; },
/* harmony export */   "T8": function() { return /* binding */ enterDuration; },
/* harmony export */   "WG": function() { return /* binding */ defaultInnerStyle; },
/* harmony export */   "hj": function() { return /* binding */ transitionBlockStyles; },
/* harmony export */   "kX": function() { return /* binding */ exitDuration; },
/* harmony export */   "pS": function() { return /* binding */ ModalDialogWithCloseStyle; },
/* harmony export */   "tZ": function() { return /* binding */ transitionInnerStyles; }
/* harmony export */ });
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(59499);
/* harmony import */ var aphrodite__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34397);
/* harmony import */ var main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96749);
/* harmony import */ var main_javascripts_styles_base_borderStyle__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(58589);
/* harmony import */ var main_javascripts_styles_base_responsiveStyle__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88433);





var enterDuration = 400;
var exitDuration = 400;
var ModalDialogWithCloseStyle = aphrodite__WEBPACK_IMPORTED_MODULE_0__/* .StyleSheet.create */ .mM.create({
  block: {
    position: "fixed",
    top: 0,
    left: 0,
    backgroundColor: "rgba(40,40,40,0.2)",
    width: "100%",
    height: "100%",
    zIndex: 1000
  },
  inner: {
    position: "absolute",
    top: "50%",
    left: "50%",
    width: "90%",
    height: "100%",
    maxHeight: "80%",
    maxWidth: "540px",
    background: "#fff",
    borderRadius: main_javascripts_styles_base_borderStyle__WEBPACK_IMPORTED_MODULE_2__/* .borderRadius.normal */ .E.normal,
    boxShadow: "0 6px 30px rgba(40,40,40,0.1)",
    boxSizing: "border-box",
    willChange: "transform"
  },
  innerContent: (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
    height: "calc(100% - 3rem)",
    marginTop: "3rem",
    overflowY: "auto",
    // "-webkitOverflowScrolling": "touch",
    padding: "0 ".concat(main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_1__/* .space.atom2x */ .D.atom2x, " 2rem"),
    boxSizing: "border-box"
  }, (0,main_javascripts_styles_base_responsiveStyle__WEBPACK_IMPORTED_MODULE_3__/* .moreThanBreakpoint */ .h6)("tablet"), {
    padding: "0 3rem 2rem"
  }),
  noInnerContentPadding: (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
    padding: 0
  }, (0,main_javascripts_styles_base_responsiveStyle__WEBPACK_IMPORTED_MODULE_3__/* .moreThanBreakpoint */ .h6)("tablet"), {
    padding: 0
  }),
  closeButton: {
    width: "3rem",
    height: "3rem",
    textAlign: "center",
    boxSizing: "border-box",
    fontSize: "24px",
    position: "absolute",
    top: 0,
    right: 0,
    cursor: "pointer",
    opacity: 0.5,
    transition: "all 0.3s ease",
    backfaceVisibility: "hidden",
    zIndex: 100,
    ":hover": {
      opacity: 1
    }
  },
  closeButtonIcon: {
    lineHeight: "3rem"
  }
});
var defaultBlockStyle = {
  transition: "all ".concat(enterDuration, "ms ease"),
  opacity: 0
};
var transitionBlockStyles = {
  entering: {
    opacity: 0
  },
  entered: {
    opacity: 1
  },
  exiting: {
    transition: "all ".concat(exitDuration, "ms ease")
  },
  exited: {
    opacity: 0,
    display: "none"
  }
};
var defaultInnerStyle = {
  transition: "all ".concat(enterDuration, "ms ease"),
  transform: "translate(-50%, -50%) scale(0.9)"
};
var transitionInnerStyles = {
  entering: {
    transform: "translate(-50%, -50%) scale(0.9)"
  },
  entered: {
    transform: "translate(-50%, -50%) scale(1)"
  },
  exiting: {
    transition: "all ".concat(exitDuration, "ms ease")
  },
  exited: {
    transform: "translate(-50%, -50%) scale(0.9)",
    display: "none"
  }
};

/***/ }),

/***/ 99717:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "T": function() { return /* reexport */ ModalDialogWithClose; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/aphrodite/es/index.js + 1 modules
var es = __webpack_require__(34397);
// EXTERNAL MODULE: ./node_modules/react-transition-group/esm/Transition.js + 1 modules
var Transition = __webpack_require__(98885);
// EXTERNAL MODULE: ./main/javascripts/components/atoms/Modal/ModalDialogWithClose/ModalDialogWithCloseStyle.ts
var ModalDialogWithCloseStyle = __webpack_require__(91435);
// EXTERNAL MODULE: ./main/javascripts/components/atoms/Icon/index.ts
var Icon = __webpack_require__(74303);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
;// CONCATENATED MODULE: ./main/javascripts/components/atoms/Modal/ModalDialogWithClose/ModalDialogWithClose.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }








var ModalDialogWithClose = function ModalDialogWithClose(props) {
  var _children = props.children,
      displayed = props.displayed,
      closeHandler = props.closeHandler,
      innerStyles = props.innerStyles,
      innerContentStyles = props.innerContentStyles,
      _props$styleKey = props.styleKey,
      styleKey = _props$styleKey === void 0 ? "default" : _props$styleKey,
      _props$styles = props.styles,
      styles = _props$styles === void 0 ? {} : _props$styles;
  var overlayStyle = styles.overlayStyle,
      innerStyle = styles.innerStyle,
      innerContentStyle = styles.innerContentStyle,
      closeButtonStyle = styles.closeButtonStyle,
      closeStyle = styles.closeStyle;
  var nodeRef = (0,react.useRef)(null);

  var onClickOverlay = function onClickOverlay(e) {
    if (!e.target.closest(".popupInner")) {
      closeHandler();
    }
  };

  var innerWidthStyle = (innerStyles === null || innerStyles === void 0 ? void 0 : innerStyles.width) && es/* StyleSheet.create */.mM.create({
    style: {
      width: innerStyles.width
    }
  });
  var innerMaxWidthStyle = (innerStyles === null || innerStyles === void 0 ? void 0 : innerStyles.maxWidth) && es/* StyleSheet.create */.mM.create({
    style: {
      maxWidth: innerStyles.maxWidth
    }
  });
  var innerHeightStyle = (innerStyles === null || innerStyles === void 0 ? void 0 : innerStyles.height) && es/* StyleSheet.create */.mM.create({
    style: {
      height: innerStyles.height
    }
  });
  var innerContentMarginStyle = (innerContentStyles === null || innerContentStyles === void 0 ? void 0 : innerContentStyles.marginTop) && es/* StyleSheet.create */.mM.create({
    style: {
      marginTop: innerContentStyles.marginTop,
      height: "calc(100% - ".concat(innerContentStyles.marginTop, ")")
    }
  });
  var innerContentPaddingStyle = styleKey !== "default" && ModalDialogWithCloseStyle/* ModalDialogWithCloseStyle */.pS[styleKey];
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Transition/* default */.ZP, {
    timeout: {
      enter: ModalDialogWithCloseStyle/* enterDuration */.T8,
      exit: ModalDialogWithCloseStyle/* exitDuration */.kX
    },
    "in": displayed,
    unmountOnExit: true,
    nodeRef: nodeRef,
    children: function children(state) {
      return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        style: _objectSpread(_objectSpread({}, ModalDialogWithCloseStyle/* defaultBlockStyle */.Dt), ModalDialogWithCloseStyle/* transitionBlockStyles */.hj[state]),
        className: (0,es/* css */.iv)(ModalDialogWithCloseStyle/* ModalDialogWithCloseStyle.block */.pS.block, overlayStyle),
        onClick: onClickOverlay,
        ref: nodeRef,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
          style: _objectSpread(_objectSpread({}, ModalDialogWithCloseStyle/* defaultInnerStyle */.WG), ModalDialogWithCloseStyle/* transitionInnerStyles */.tZ[state]),
          className: "".concat((0,es/* css */.iv)(ModalDialogWithCloseStyle/* ModalDialogWithCloseStyle.inner */.pS.inner, innerWidthStyle === null || innerWidthStyle === void 0 ? void 0 : innerWidthStyle.style, innerMaxWidthStyle === null || innerMaxWidthStyle === void 0 ? void 0 : innerMaxWidthStyle.style, innerHeightStyle === null || innerHeightStyle === void 0 ? void 0 : innerHeightStyle.style, innerStyle), " popupInner"),
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            className: (0,es/* css */.iv)(ModalDialogWithCloseStyle/* ModalDialogWithCloseStyle.innerContent */.pS.innerContent, innerContentPaddingStyle, innerContentMarginStyle === null || innerContentMarginStyle === void 0 ? void 0 : innerContentMarginStyle.style, innerContentStyle),
            children: _children
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            onClick: closeHandler,
            className: (0,es/* css */.iv)(ModalDialogWithCloseStyle/* ModalDialogWithCloseStyle.closeButton */.pS.closeButton, closeButtonStyle),
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon/* Icon */.J, {
              styleKey: "close",
              styles: [ModalDialogWithCloseStyle/* ModalDialogWithCloseStyle.closeButtonIcon */.pS.closeButtonIcon, closeStyle]
            })
          })]
        })
      });
    }
  });
};
;// CONCATENATED MODULE: ./main/javascripts/components/atoms/Modal/ModalDialogWithClose/index.ts


/***/ }),

/***/ 95284:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ Button; }
/* harmony export */ });
/* unused harmony export buttonStyle */
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(4730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(70917);
/* harmony import */ var main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36716);
/* harmony import */ var main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(80910);
/* harmony import */ var main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96749);
/* harmony import */ var main_javascripts_styles_base_borderStyle__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(58589);
/* harmony import */ var main_javascripts_styles_base_responsiveStyle__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(88433);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(35944);


var _excluded = ["children", "styleKey"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }











// 旧コンポーネントにあったラッパーdivを削除しているので注意
// 余白は上位コンポーネントで設定する
var ButtonComponent = function ButtonComponent(props) {
  var children = props.children,
      _props$styleKey = props.styleKey,
      styleKey = _props$styleKey === void 0 ? "button" : _props$styleKey,
      rest = (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(props, _excluded);

  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)("button", _objectSpread(_objectSpread({
    css: buttonStyle[styleKey]
  }, rest), {}, {
    children: children
  }));
};

var Button = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.memo(ButtonComponent);
var buttonBaseStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__.css)("position:relative;box-sizing:border-box;overflow:hidden;text-align:center;outline:none;cursor:pointer;text-decoration:none;letter-spacing:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_2__/* .letterSpacing.text */ .rX.text, ";border-radius:", main_javascripts_styles_base_borderStyle__WEBPACK_IMPORTED_MODULE_5__/* .borderRadius.normal */ .E.normal, ";margin:0;width:100%;transition:background 0.4s ease,opacity 0.4s ease;" + ( true ? "" : 0),  true ? "" : 0);
var buttonDefaultBaseStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__.css)(buttonBaseStyle, ";font-weight:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_2__/* .fontWeight.regular */ .Ue.regular, ";color:white;background-color:", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_3__/* .accentColor.primaryColor */ .z.primaryColor, ";padding:0 ", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_4__/* .space.atom */ .D.atom, ";border:none;min-width:64px;&:hover{background-color:", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_3__/* .accentColor.primaryDarkColor */ .z.primaryDarkColor, ";}&:disabled{opacity:0.75;cursor:default;&:hover{background-color:", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_3__/* .accentColor.primaryColor */ .z.primaryColor, ";}}", (0,main_javascripts_styles_base_responsiveStyle__WEBPACK_IMPORTED_MODULE_6__/* .minResolution */ .UW)("scale2x"), "{font-weight:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_2__/* .fontWeight.medium */ .Ue.medium, ";}" + ( true ? "" : 0),  true ? "" : 0);
var buttonDefaultSecondaryBaseStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__.css)(buttonBaseStyle, ";font-weight:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_2__/* .fontWeight.regular */ .Ue.regular, ";color:", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_3__/* .accentColor.primaryColor */ .z.primaryColor, ";background-color:#fff;padding:0 ", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_4__/* .space.atom */ .D.atom, ";border:1px solid ", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_3__/* .accentColor.primaryColor */ .z.primaryColor, ";min-width:64px;&:hover{opacity:0.7;}&:disabled{opacity:0.3;cursor:default;&:hover{background-color:#fff;}}" + ( true ? "" : 0),  true ? "" : 0);
var buttonAlertBaseStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__.css)(buttonBaseStyle, ";font-weight:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_2__/* .fontWeight.regular */ .Ue.regular, ";color:white;background-color:", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_3__/* .accentColor.alertColor */ .z.alertColor, ";padding:0 ", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_4__/* .space.atom */ .D.atom, ";border:none;min-width:64px;&:hover{background-color:", (0,main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_3__/* .shadeColorLogHex */ ._S)(main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_3__/* .accentColor.alertColor */ .z.alertColor, 1, 0.1), ";}&:disabled{opacity:0.5;cursor:default;&:hover{background-color:", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_3__/* .accentColor.alertColor */ .z.alertColor, ";}}", (0,main_javascripts_styles_base_responsiveStyle__WEBPACK_IMPORTED_MODULE_6__/* .minResolution */ .UW)("scale2x"), "{font-weight:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_2__/* .fontWeight.medium */ .Ue.medium, ";}" + ( true ? "" : 0),  true ? "" : 0);
var buttonAlertSecondaryBaseStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__.css)(buttonBaseStyle, ";font-weight:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_2__/* .fontWeight.regular */ .Ue.regular, ";color:", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_3__/* .accentColor.alertColor */ .z.alertColor, ";background-color:#fff;padding:0 ", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_4__/* .space.atom */ .D.atom, ";border:1px solid ", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_3__/* .accentColor.alertColor */ .z.alertColor, ";min-width:64px;" + ( true ? "" : 0),  true ? "" : 0);
var buttonStyle = {
  button: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__.css)(buttonDefaultBaseStyle, ";font-size:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_2__/* .fontSize.mediumHeading */ .JB.mediumHeading, ";height:40px;line-height:40px;" + ( true ? "" : 0),  true ? "" : 0),
  buttonSmall: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__.css)(buttonDefaultBaseStyle, ";font-size:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_2__/* .fontSize.subHeading */ .JB.subHeading, ";height:40px;line-height:40px;", (0,main_javascripts_styles_base_responsiveStyle__WEBPACK_IMPORTED_MODULE_6__/* .moreThanBreakpoint */ .h6)("tablet"), "{height:36px;line-height:36px;}" + ( true ? "" : 0),  true ? "" : 0),
  buttonSecondary: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__.css)(buttonDefaultSecondaryBaseStyle, ";font-size:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_2__/* .fontSize.mediumHeading */ .JB.mediumHeading, ";height:40px;line-height:38px;" + ( true ? "" : 0),  true ? "" : 0),
  buttonSmallSecondary: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__.css)(buttonDefaultSecondaryBaseStyle, ";font-size:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_2__/* .fontSize.subHeading */ .JB.subHeading, ";height:40px;line-height:38px;", (0,main_javascripts_styles_base_responsiveStyle__WEBPACK_IMPORTED_MODULE_6__/* .moreThanBreakpoint */ .h6)("tablet"), "{height:36px;line-height:34px;}" + ( true ? "" : 0),  true ? "" : 0),
  buttonAdd: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__.css)(buttonDefaultSecondaryBaseStyle, ";font-size:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_2__/* .fontSize.body */ .JB.body, ";height:32px;line-height:30px;background:none;" + ( true ? "" : 0),  true ? "" : 0),
  buttonRemove: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__.css)(buttonDefaultSecondaryBaseStyle, ";color:", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_3__/* .accentColor.secondaryColor */ .z.secondaryColor, ";border-color:", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_3__/* .accentColor.secondaryColor */ .z.secondaryColor, ";font-size:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_2__/* .fontSize.body */ .JB.body, ";height:32px;line-height:30px;background:none;" + ( true ? "" : 0),  true ? "" : 0),
  buttonAlert: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__.css)(buttonAlertBaseStyle, ";font-size:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_2__/* .fontSize.mediumHeading */ .JB.mediumHeading, ";height:40px;line-height:38px;" + ( true ? "" : 0),  true ? "" : 0),
  buttonSmallAlert: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__.css)(buttonAlertBaseStyle, ";font-size:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_2__/* .fontSize.subHeading */ .JB.subHeading, ";height:40px;line-height:38px;", (0,main_javascripts_styles_base_responsiveStyle__WEBPACK_IMPORTED_MODULE_6__/* .moreThanBreakpoint */ .h6)("tablet"), "{height:36px;line-height:34px;}" + ( true ? "" : 0),  true ? "" : 0),
  buttonAlertSecondary: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__.css)(buttonAlertSecondaryBaseStyle, ";font-size:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_2__/* .fontSize.mediumHeading */ .JB.mediumHeading, ";height:40px;line-height:38px;" + ( true ? "" : 0),  true ? "" : 0),
  buttonSmallAlertSecondary: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__.css)(buttonAlertSecondaryBaseStyle, ";font-size:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_2__/* .fontSize.subHeading */ .JB.subHeading, ";height:40px;line-height:38px;", (0,main_javascripts_styles_base_responsiveStyle__WEBPACK_IMPORTED_MODULE_6__/* .moreThanBreakpoint */ .h6)("tablet"), "{height:36px;line-height:34px;}" + ( true ? "" : 0),  true ? "" : 0),
  buttonSubmit: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__.css)("position:relative;font-size:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_2__/* .fontSize.mediumHeading */ .JB.mediumHeading, ";font-weight:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_2__/* .fontWeight.regular */ .Ue.regular, ";color:white;background-color:", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_3__/* .accentColor.primaryColor */ .z.primaryColor, ";padding:0 ", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_4__/* .space.atom */ .D.atom, ";border:none;border-radius:", main_javascripts_styles_base_borderStyle__WEBPACK_IMPORTED_MODULE_5__/* .borderRadius.normal */ .E.normal, ";margin:0;width:100%;min-width:64px;height:54px;line-height:54px;box-sizing:border-box;overflow:hidden;text-align:center;outline:none;cursor:pointer;text-decoration:none;letter-spacing:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_2__/* .letterSpacing.text */ .rX.text, ";transition:background 0.4s ease,opacity 0.4s ease;&:before{content:\"\";border:1px solid #fff;display:block;border-radius:3px;position:absolute;top:50%;left:50%;width:calc(100% - ", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_4__/* .space.atom */ .D.atom, ");height:calc(100% - ", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_4__/* .space.atom */ .D.atom, ");transform:translate(-50%, -50%);box-sizing:border-box;}&:hover{background-color:", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_3__/* .accentColor.primaryDarkColor */ .z.primaryDarkColor, ";}&:disabled{opacity:0.5;}", (0,main_javascripts_styles_base_responsiveStyle__WEBPACK_IMPORTED_MODULE_6__/* .minResolution */ .UW)("scale2x"), "{font-weight:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_2__/* .fontWeight.medium */ .Ue.medium, ";}" + ( true ? "" : 0),  true ? "" : 0)
}; // const blockStyle = css`
//   padding: ${space.atom};
// `;

/***/ }),

/***/ 19484:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "H": function() { return /* reexport */ FullScreenModalDialog; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./main/javascripts/components/atoms/Modal/ModalDialogWithClose/index.ts + 1 modules
var ModalDialogWithClose = __webpack_require__(99717);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/aphrodite/es/index.js + 1 modules
var es = __webpack_require__(34397);
// EXTERNAL MODULE: ./main/javascripts/styles/base/responsiveStyle.ts
var responsiveStyle = __webpack_require__(88433);
;// CONCATENATED MODULE: ./main/javascripts/components/molecules/Modal/FullScreenModalDialog/FullScreenModalDialogStyle.ts



var FullScreenModalDialogStyle = es/* StyleSheet.create */.mM.create({
  inner: {
    backgroundColor: "#232323",
    width: "calc(100% + 1px)",
    height: "calc(100% + 1px)",
    maxWidth: "calc(100% + 1px)",
    maxHeight: "calc(100% + 1px)",
    boxShadow: "none",
    borderRadius: 0,
    paddingLeft: 0,
    paddingRight: 0
  },
  innerContent: (0,defineProperty/* default */.Z)({
    padding: 0,
    overflow: "hidden"
  }, (0,responsiveStyle/* moreThanBreakpoint */.h6)("tablet"), {
    padding: 0
  }),
  closeButton: {
    opacity: 1,
    ":hover": {
      opacity: 0.7
    }
  },
  close: {
    color: "#fff"
  },
  innerLight: {
    backgroundColor: "#fff",
    width: "calc(100% + 1px)",
    height: "calc(100% + 1px)",
    maxWidth: "calc(100% + 1px)",
    maxHeight: "calc(100% + 1px)",
    boxShadow: "none",
    borderRadius: 0,
    paddingLeft: 0,
    paddingRight: 0
  },
  closeLight: {
    color: "#232323"
  }
});
// EXTERNAL MODULE: ./main/javascripts/utils/ScrollUtil.ts
var ScrollUtil = __webpack_require__(75215);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
;// CONCATENATED MODULE: ./main/javascripts/components/molecules/Modal/FullScreenModalDialog/FullScreenModalDialog.tsx





var FullScreenModalDialog = function FullScreenModalDialog(props) {
  var children = props.children,
      header = props.header,
      displayed = props.displayed,
      closeHandler = props.closeHandler,
      colorMode = props.colorMode,
      _props$disableStopBod = props.disableStopBodyScrolling,
      disableStopBodyScrolling = _props$disableStopBod === void 0 ? false : _props$disableStopBod;
  (0,react.useEffect)(function () {
    if (!disableStopBodyScrolling) {
      (0,ScrollUtil/* stopBodyScrolling */.wV)(displayed);
    }
  }, [displayed]);
  (0,react.useEffect)(function () {
    return function () {
      if (!disableStopBodyScrolling) {
        (0,ScrollUtil/* stopBodyScrolling */.wV)(false);
      }
    };
  }, []);
  var innerStyle = FullScreenModalDialogStyle.inner;
  var closeStyle = FullScreenModalDialogStyle.close;
  var closeButtonStyle = FullScreenModalDialogStyle.closeButton;
  var innerContentStyle = FullScreenModalDialogStyle.innerContent;

  if (colorMode === "light") {
    innerStyle = FullScreenModalDialogStyle.innerLight;
    closeStyle = FullScreenModalDialogStyle.closeLight;
  }

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ModalDialogWithClose/* ModalDialogWithClose */.T, {
    displayed: displayed,
    closeHandler: closeHandler,
    styles: {
      innerStyle: innerStyle,
      innerContentStyle: innerContentStyle,
      closeButtonStyle: closeButtonStyle,
      closeStyle: closeStyle
    },
    children: [header, children]
  });
};
;// CONCATENATED MODULE: ./main/javascripts/components/molecules/Modal/FullScreenModalDialog/index.ts


/***/ })

}]);